const updateArray = (setter, array, index, value) => {
    const newArray = [...array];

    if (typeof value === "object") {
        newArray[index] = { ...newArray[index], ...value };
    } else {
        newArray[index] = value;
    }
    setter(newArray);
};

const removeArrayItem = (setter, array, index, refs) => {
    const newArray = [...array];
    newArray.splice(index, 1);
    if (refs) {
        refs.current.splice(index, 1);
    }
    setter(newArray);
};

const addArrayItem = (setter, defaultValue, refs) => {
    setter((prev) => {
        const updatedArray = [...prev, defaultValue];
        if (refs) {
            setTimeout(() => {
                const lastIndex = updatedArray.length - 1;
                if (refs.current[lastIndex]) {
                    refs.current[lastIndex].focus();
                }
            }, 0);
        }
        return updatedArray;
    });
};

const updateICDArray = (setter, array, cptIndex, icdIndex, value) => {
    const newArray = [...array];

    if (!newArray[cptIndex]) {
        newArray[cptIndex] = [];
    }

    newArray[cptIndex][icdIndex] = value;
    setter(newArray);
};

const removeICDArrayItem = (setter, array, cptIndex, icdIndex, refs) => {
    const newArray = [...array];

    if (newArray[cptIndex]) {
        newArray[cptIndex].splice(icdIndex, 1);

        if (newArray[cptIndex].length === 0) {
            newArray[cptIndex] = [];
        }
    }

    if (!Array.isArray(refs.current[cptIndex])) {
        refs.current[cptIndex] = [];
    }

    refs.current[cptIndex] = refs.current[cptIndex].filter((_, index) => index !== icdIndex);

    setter(newArray);
};

const addICDArrayItem = (setter, array, cptIndex, refs) => {
    setter((prev) => {
        const newArray = [...prev];

        // Ensure all previous indices are initialized (if empty, set to [])
        for (let i = 0; i <= cptIndex; i++) {
            if (!newArray[i]) {
                newArray[i] = [];
            }
        }

        if (!newArray[cptIndex]) {
            newArray[cptIndex] = [];
        }

        newArray[cptIndex].push("");

        setTimeout(() => {
            const lastIndex = newArray[cptIndex].length - 1;
            if (refs.current[cptIndex] && refs.current[cptIndex][lastIndex]) {
                refs.current[cptIndex][lastIndex].focus();
            }
        }, 0);

        return newArray;
    });
};


export {
    updateArray,
    removeArrayItem,
    addArrayItem,
    updateICDArray,
    removeICDArrayItem,
    addICDArrayItem
};